import defaultTheme from './defaultTheme';
const googleTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#444444', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#444444', background: '#444444' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#444444' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#444444', border: '#444444', background: '#444444' }), field: {
        focus: '#444444',
        label: '#444444',
        icon: '#444444',
    } });
export default googleTheme;
